import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';
import {ShipmentsService} from '../services/shipments.service';
import {Shipment} from '../services/shipment';
import {ShipmentEditModalComponent} from '../shipment-edit-modal/shipment-edit-modal.component';
import {NgbModal, NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import {ShipmentRoutesService} from '../services/shipment-routes.service';
import {ShipmentRoute} from '../services/shipment-route';
import {NgbPopoverConfig} from '@ng-bootstrap/ng-bootstrap';
import {OrderLineStatus} from '../services/shipment-product-line';
import {byPropertiesOf} from "../pipes/sort-by-pipe";
import {orderBy} from "lodash";
import {environment} from "../../environments/environment";
import {faArrowRotateBack} from "@fortawesome/free-solid-svg-icons";

declare let NProgress: any;

@Component({
    providers: [NgbPopoverConfig],
    selector: 'app-shipping-system-table',
    templateUrl: './shipping-system-table.component.html',
    styleUrls: ['./shipping-system-table.component.scss']
})
export class ShippingSystemTableComponent implements OnInit, OnChanges {

    @Input() enableTempSorting: boolean = false;
    @Input() sortfield = 'sorting';
    @Input() shipmentRoutes: ShipmentRoute[] = [];
    @Input() branch: string[];

    saving = false;
    optimizingRoute = false;

    @Output() shipmentsChanged = new EventEmitter<any>();
    @Output() routeChanged = new EventEmitter<any>();

    @Input() shipmentRoute: ShipmentRoute;
    @Input() shipmentRouteId: string;
    @Input() showHeader: boolean;
    @Input() header: string = null;
    @Input() shipments: Shipment[];
    @Input() expandOrderLines: boolean;
    @Input() showDate = false;

    constructor(public router: Router,
                public ngbModal: NgbModal,
                public shipmentsService: ShipmentsService,
                public shipmentRoutesService: ShipmentRoutesService,
                config: NgbPopoverConfig) {
        // customize popovers
        config.placement = 'bottom';
        config.triggers = 'hover';
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.shipmentRoutes) {
            this.shipmentRoutes = this.shipmentRoutes.filter((route => route.branch === this.branch[0]));
        }
    }

    // _allshipments: Shipment[];
    // get shipments(): Shipment[] {
    //     return this._allshipments.filter((item) => {
    //         if (this.expandOrderLines) {
    //             let status = item.getProductLinesStatus()
    //             if (status === OrderLineStatus.Ok) {
    //                 return false
    //             }
    //             return true;
    //         } else {
    //             return true;
    //         }
    //     });
    // }
    // @Input() set shipments(value: Shipment[]) {
    //     console.log(value);
    //     this._allshipments = value;
    // }
    showTraficLights: boolean= false;


    edit(shipment: Shipment, editCoords?: boolean) {
        const modalRef = this.ngbModal.open(ShipmentEditModalComponent, {size: 'xxl'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipment = shipment;
        if (editCoords) {
            modalRef.componentInstance.showAddress = true;
        } else {
            modalRef.componentInstance.showDriver = true;
        }
        modalRef.componentInstance.saved = (result) => {
            this.shipmentsChanged.emit();
        };
    }

    events(shipment: Shipment) {
        const modalRef = this.ngbModal.open(ShipmentEditModalComponent, {size: 'xl'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipment = shipment;
        modalRef.componentInstance.showEvents = true;
        modalRef.componentInstance.saved = (result) => {
            this.shipmentsChanged.emit();
        };
    }

    saveTableOrder2($event, print = false) {
        console.log('saveTableOrder', $event);

        console.log('callback');
        if (!this.shipments || this.shipments.length === 0) {
            return;
        }

        this.saving = true;
        const shipments = [];
        let i = 0;

        for (const shipment of $event) {
            shipments.push({
                id: shipment.id,
                shipment_route_id: this.shipmentRoute ? this.shipmentRoute.id : null,
                [this.sortfield]: i
            });

            i++;
        }

        this.shipmentsService.updateShipments(shipments, {print: print}).then((shipments) => {
            this.saving = false;
        });

    }
    saveTableOrder(print: boolean = false) {


    }

    canOptimize() {
        return this.shipments.length >= 1 && this.shipments.length <= 10
    }

    isAllReady() {
        for (const shipment of this.shipments) {
            if (shipment.shipment_status === 'new' || shipment.shipment_status === 'in_stock') {
                return false;
            }
        }

        return true;
    }

    updateStock() {
        this.saving = true;
        let branch;
        const shipments = [];
        let i = 0;
        for (const shipment of this.shipments) {
            branch = shipment.branch;
            shipments.push(shipment.id);
            i++;
        }
        this.shipmentsService.updateStock(branch, shipments).then(shipments => {
            this.shipmentsChanged.emit();
            this.saving = false;
        });
    }

    markReady() {
        this.saving = true;
        const shipments = [];
        let i = 0;
        for (const shipment of this.shipments) {
            if (shipment.shipment_status !== 'deleted' && shipment.shipment_status !== 'complete' && shipment.shipment_status !== 'shipped') {
                shipments.push({
                    id: shipment.id,
                    shipment_status: 'ready_to_ship'
                });

                i++;
            }
        }
        this.shipmentsService.updateShipments(shipments).then(shipments => {
            this.shipmentsChanged.emit();
            this.saving = false;
        });
    }

    showRoute() {
        const completeShipments = [].concat([this.shipmentRoutesService.getBranchShipment(this.shipmentRoute)], this.shipments, [this.shipmentRoutesService.getBranchShipment(this.shipmentRoute)])
        this.shipmentRoutesService.getRoute(completeShipments, this.shipmentRoute.branch).then(response => {
            response.shipments = completeShipments;

            this.routeChanged.emit(response);
        });
    }

    printRoute() {
        const newWindow = window.open('', '_blank');
        this.shipmentsService.printShipments(this.shipments).subscribe((response) => {
            const fileUrl = URL.createObjectURL(response);
            newWindow.location.href = fileUrl;
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = 'route.pdf';
            link.click();
        });
    }

    reverseRoute() {
        this.optimizingRoute = true;
        _.reverse(this.shipments);
        this.saveTableOrder2(this.shipments);
        this.optimizingRoute = false;
    }

    optimizeRoute() {
        this.optimizingRoute = true;
        this.shipmentsService.optimize(this.shipments).subscribe((response: any) => {
            this.optimizingRoute = false;
            this.shipmentsChanged.emit();
        });
    }

    exportGpx() {
        const newWindow = window.open('', '_blank');
        this.optimizingRoute = true;
        this.shipmentsService.exportGpx(this.shipments).subscribe((response:any) => {
            const fileUrl = URL.createObjectURL(response);
            newWindow.location.href = fileUrl;
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = 'route.gpx';
            link.click();
            this.optimizingRoute = false;
        });
    }

    protected startRoute() {
            this.optimizingRoute = true;
        this.shipmentsService.startRoute(this.shipments).subscribe((response:any) => {
            this.optimizingRoute = false;
            this.shipmentsChanged.emit();
        });
    }

    updateShipment(shipment, p?: NgbPopover) {
        if (p) {
            p.close();
        }
        this.saving = true;
        this.shipmentsService.updateShipment(shipment).then(shipments => {
            this.shipmentsChanged.emit();
            this.saving = false;
        });
    }

    printSingle(shipment) {
        this.shipmentsService.updateShipment(shipment, {print: true}).then(() => {

        })
    }

    applyPaint(shipment: Shipment) {

        if (!this.shipmentsService.paintData.active) {
            return;
        }

        if (
            this.shipmentsService.paintData.shipmentRoute && this.shipmentsService.paintData.shipmentRoute.id
        ) {
            shipment.shipment_route_id = this.shipmentsService.paintData.shipmentRoute.id;
        }

        if (this.shipmentsService.paintData.shipping_date && this.shipmentsService.paintData.shipping_date.isValid()) {
            shipment.shipping_date = this.shipmentsService.paintData.shipping_date;
        }
        this.updateShipment(shipment);
    }

    changeSort(sortKey: 'order_reference' | 'nota_number' | 'order_date' | 'shipping_date') {
        this.shipments = this.shipments.sort(byPropertiesOf<Shipment>([sortKey]));
    }

    changeSortNested(zip: string) {
        this.shipments = orderBy(this.shipments, zip);
    }



    protected readonly environment = environment;
    protected readonly ShipmentsService = ShipmentsService;
    protected readonly faArrowRotateBack = faArrowRotateBack;
}
